<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Bill Number</th>
                    <th class="text-right">Bill Amount</th>
                    <th>Party Name</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td> {{ item.date }}</td>
                    <td> {{ item.bill_number }}</td>
                    <td class="text-right"> {{ item.bill_amount }}</td>
                    <td> {{ item.party_name }}</td>
                    <td>
                      <button class="btn btn-primary btn-sm"
                              @click="goToEditPage(item.id)"
                              style="cursor: pointer; margin-left: 10px"
                      >
                          <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        class="btn btn-danger btn-sm p-0"
                        @click="goToReturnPage(item.id)"
                        style="cursor: pointer; margin-left: 10px"
                        v-if="! ['returned', 'partially_returned'].includes(item.status)"
                      >
                        <i class="far fa-window-close" style="font-size: 1.3em; margin: 5px 10px"></i>
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="goToReturnPage(item.id, true)"
                        style="cursor: pointer; margin-left: 10px"
                        v-if="item.status !== 'returned'"
                      >
                        <i class="fas fa-undo-alt"></i>
                      </button>
                      <div class="dropdown d-inline-block" style="margin-left: 10px">
                        <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                          <i class="fas fa-print"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-item" href="#" @click.prevent="goToPrint(item.id, false)">
                              Print
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item" href="#" @click.prevent="goToPrint(item.id, true)">
                              Print with Signature
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>

import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import handlePurchase from "@/services/modules/purchase";
import useDate from "@/services/utils/day";
import handleBarcode from "@/services/modules/barcode";
import pdfPrinter from "@/services/utils/pbPdfPrinter";
import handleCompany from "@/services/modules/company";
import { ref, onMounted, inject } from "vue";

const props = defineProps({
  purchase: {
    type: Array,
    default: []
  },
  companyInfo: {
    type: Object,
    default: null
  }
})

const router = useRouter();
const route = useRoute();
const store = useStore()
const showError = inject('showError')
const { fetchPurchaseBill } = handlePurchase()
const { formatDate} = useDate()
const { fetchBarcode } = handleBarcode();
const { exportToPDF } = pdfPrinter();
const { fetchActiveCustomizationField } = handleCompany();

const customizationPdfFields = ref({})

onMounted(() => {
  getActiveFieldCustomization()
})

const getActiveFieldCustomization = () => {
  const companyQuery = `?company_id=${route.params.companyId}&customization_type=pdf&type=purchase_bill_list_pdf`;
  fetchActiveCustomizationField(companyQuery).then((res) => {
    if (!res.status) return
    customizationPdfFields.value = res.data
  })
}

const goToReturnPage = (billId, isPartial = false) => {

  const params = {
    companyId : route.params.companyId,
    menuId : route.params.menuId,
    pageId : route.params.pageId,
    billId : billId,
  }

  const name = isPartial ? 'purchase-bill-partial-return' : 'purchase-bill-return';

  router.push({name, params, query: route.query})
}

const goToEditPage = (purchaseId) => {
  const params = {
    companyId : route.params.companyId,
    menuId : route.params.menuId,
    pageId : route.params.pageId,
    purchaseId
  }

  router.push({name: 'purchase-bill-edit-2', params, query: route.query})
}

const goToPrint = (id, isDynamic = false) => {
  const user = store.state.user.user
  const companyQuery = `?company_id=${route.params.companyId}`;
  let barcodeQuery = "";
  let qrcode = null
  let barcode = null
  let purchaseBill = null

  fetchPurchaseBill(id, companyQuery).then( (res) =>{
    if( res ){
      purchaseBill = res.data;
      let qrcodeData = JSON.stringify({
        ref_no: purchaseBill.bill_number,
        ref_date: purchaseBill.date,
        created_by: user.name,
        created_date_time: formatDate(new Date())
      })
      barcodeQuery = `?code=${purchaseBill.bill_number}&qrcode=${qrcodeData}`;
    }}).then (() => {
      return fetchBarcode(barcodeQuery).then( (res) => {
        barcode = res.barcode;
        qrcode = res.qrcode
      }).then( () => {
        exportToPDF(props.companyInfo, purchaseBill, barcode, qrcode, user.name, 1, false, customizationPdfFields.value, isDynamic)
      })
    }).catch(() => {
      showError('Failed to print purchase bill')
    })
}
</script>

<style scoped>
.table-responsive {
  overflow: visible;
}

.dropdown-menu {
  min-width: 180px;
}
</style>
